import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/bulk-import/templates')({ component: Outlet });
